<template>
    <div class="lease-filter" :class="{ open: openState}">
        <div class="lease-filter-wrap">
            <div class="filter-title">
                <img src="../../../assets/img/icon/filter_gray.svg" alt="">
                篩選
            </div>
            <div class="default period">
                <div class="title level1-title-font">租期</div>
                <date-picker v-model="leaseFilter.contractDate" :class="{'active': leaseFilter.contractDate[0] != null}" placeholder="2020.05.06 2020.05.06" format="YYYY.MM.DD" range ></date-picker>
            </div>
            <div class="default location">
                <div class="title level1-title-font">地點</div>
                <div class="group">
                    <rent-select class="select-scroll" refName="county" selectMsg="所有縣市" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="filterCountyIsEmpty">
                        <ul>
                            <li :data-id="index" :data-name="county" v-for="(county, index) in countyResult" :key="index">
                                {{county}}
                            </li>
                        </ul>
                    </rent-select>
                    <rent-select class="select-scroll" refName="district" selectMsg="所有區域" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="filterDistrictIsEmpty">
                        <ul v-if="leaseFilter.countyId">
                            <li :data-id="index" :data-name="district.districtName" v-for="(district, index) in districtsResult" :key="index">
                                {{district.districtName}}
                            </li>
                        </ul>
                    </rent-select>
                </div>
            </div>
            <div class="default rent-date">
                <div class="title level1-title-font">收租日</div>
                <date-picker v-model="leaseFilter.rentDate" :class="{'active': leaseFilter.rentDate != ''}" placeholder="2020.05.06" format="YYYY.MM.DD"></date-picker>
            </div>
            <div class="default deposit">
                <div class="title level1-title-font">押金</div>
                <vue-slider v-model="leaseFilter.desposit" :min="0" :max="100000" :width="214" :height="2" tooltip="always" :tooltip-placement="'bottom'" :tooltip-formatter="val => numValue(val)" :enableCross="true"/>
            </div>
            <div class="default rent">
                <div class="title level1-title-font">租金</div>
                <vue-slider v-model="leaseFilter.rent" :min="0" :max="100000" :width="214" :height="2" tooltip="always" :tooltip-placement="'bottom'" :tooltip-formatter="val => numValue(val)" :enableCross="true"/>
            </div>
            <div class="default arrears">
                <div class="title level1-title-font">是否欠款</div>
                <rent-select refName="arrears" selectMsg="所有" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="filterArrearsIsEmpty">
                    <ul>
                        <li data-id="1">
                            有欠款
                        </li>
                        <li data-id="0">
                            無欠款
                        </li>
                    </ul>
                </rent-select>
            </div>
            <div class="result">
                <div class="view-result" @click="filterClose">
                    查看搜尋結果  {{filterTotal}}
                </div>
            </div>
        </div>
        <span class="close" @click="filterClose">
            <img src="../../../assets/img/icon/cross_white.svg" alt="">
        </span>
    </div>
</template>
<script>
import VueSlider from 'vue-slider-component'
import '@/assets/css/rent.css'

import RentSelect from '@/components/widge/RentSelect.vue';
import VueRangeSlider from 'vue-range-component'
import DatePicker from 'vue2-datepicker';
import { mapGetters } from 'vuex'

export default {
    name: 'LeaseFilter',
    data () {
        return {
            openState: this.isOpen,
            leaseFilter: {
                county: '',
                countyId: '',
                district: '',
                desposit: [0, 100000],
                rent: [0, 100000],
                rentDate: '',
                arrears: '',
                contractDate: [null, null],
            },
        }
    },
    created () {
        this.formatter = value => {
            if( value >= 100000){
                return `$${value}+`
            }else{
                return `$${value}`
            }
        }
    },
    props: {
        isOpen: Boolean,
        taskHouseInfo: Object
    },
    watch: {
        isOpen (val) {
            this.openState = val
        },
        leaseFilter: {
            handler: function () {
                this.$emit('changeFilter', this.leaseFilter)
            },
            deep: true
        },
    },
    methods: {
        filterClose: function () {
            this.$emit('filterClose', false);
        },
        getSelectId: function (value) {
            if( value.ref == 'county' ){
                this.leaseFilter.county = value.name
                this.leaseFilter.countyId = value.id
                this.$store.dispatch('getDistrict',(parseInt(value.id)+1))
            }else if( value.ref == 'district' ){
                this.leaseFilter.district = value.name
            }else if( value.ref == 'arrears' ){
                this.leaseFilter.arrears = value.id
            }
        },
        numValue: function (val) {
            if( val == '100000' ){
                return '$'+this.toCurrency(val)+'+'
            }else{
                return '$'+this.toCurrency(val)
            }
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     // console.log(parts);
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // }
    },
    computed: {
        // formatter (value) {
        //     return `$${value}`
        // },
        ...mapGetters({
            countyResult: 'COUNTY_RESULT',
            districtsResult: 'DISTRICTS_RESULT',
            filterTotal: 'GET_LEASE_MGT_FILTER_RESULT_TOTAL',
            filterCountyIsEmpty: 'GET_LEASE_MGT_FILTER_COUNTY_IS_EMPTY',
            filterDistrictIsEmpty: 'GET_LEASE_MGT_FILTER_DISTRICT_IS_EMPTY',
            filterArrearsIsEmpty: 'GET_LEASE_MGT_FILTER_ARREARS_IS_EMPTY'
        })
    },
    components: {
        RentSelect,
        VueSlider,
        DatePicker,
    }
}
</script>
<style lang="scss" scoped>
    .lease-filter{
        position: fixed;
        width: 279px;
        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
        background-color: #ffffff;
        height: 100%;
        top: 0;
        right: -315px;
        transition: all 1s ease-in-out;
        z-index: 10;
        .lease-filter-wrap{
            position: relative;
            height: 100%;
            .default{
                padding: 20px;
                border-bottom: 1px solid #f0f0f0;
                .title{
                    margin-bottom: 16px;
                }
            }
            .filter-title{
                display: flex;
                align-items: center;
                padding: 24px;
                color: #a8a5a4;
                border-bottom: 1px solid #f0f0f0;
                img{
                    margin-right: 8px;
                }
            }
            .location{
                .group{
                    display: flex;
                    .rent-select:nth-child(1){
                        margin-right: 10px;
                    }
                    .rent-select{
                        width: 75px;
                        height: 18px;
                    }
                }
            }
            .period,
            .rent-date{
                .mx-datepicker {
                    width: 230px;
                    .mx-input-wrapper{
                        .mx-input{
                            height: 46px;
                            border-radius: 4px;
                            border: solid 1px #e0dfde;
                            color: #a8a5a4;
                            padding: 13px 16px;
                            box-shadow: none;
                        }
                        .mx-icon-calendar,
                        .mx-icon-clear{
                            right: 18px;
                        }
                    }
                }
                .mx-datepicker.active{
                    input{
                        border: 1px solid #676362 !important;
                        color: #676362 !important;
                    }
                    i{
                        color: #676362;
                    }
                }
                .mx-datepicker:hover{
                    .mx-input-wrapper{
                        .mx-input{
                            border: 1px solid #676362 !important;
                            color: #676362 !important;
                        }
                    }
                }
            }
            .deposit,
            .rent{
                padding-bottom: 40px;
            }
            .result{
                position: absolute;
                width: 100%;
                height: 76px;
                bottom: 0px;
                display: flex;
                align-items: center;
                justify-content: center;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                .view-result{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #ffffff;
                    font-weight: 500;
                    width: 231px;
                    height: 44px;
                    border-radius: 4px;
                    background-color: #ff9275;
                    cursor: pointer;
                }
            }
        }
        .close{
            position: absolute;
            width: 30px;
            height: 44px;
            background-color: #ff9275;
            border-radius: 10px 0 0 10px;
            left: -30px;
            top: 50%;
            transform: translateY(-50%);
            display: flex;
            align-items: center;
            justify-content: center;
            img{
                cursor: pointer;
            }
        }
    }
    .lease-filter.open{
        right: 0px;
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/leaseManagement/LeaseFilter.vue